import React, { useState } from "react";
import AdminVaultBarcode from "./AdminVaultBarcode";
import AdminVaultSettings from "./AdminVaultSettings";
import { Scan, Settings2 } from "lucide-react";

export default function AdminVault() {
  const [tab, setTab] = useState("barcode");

  return (
    <div className="p-4 sm:p-6 md:p-10" data-testid="admin-vault">
      <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-3 mb-6">
        <div>
          <div className="text-[11px] tracking-[0.04em] text-[var(--text-muted)] font-medium flex items-center gap-2">
            <Scan size={11} className="text-[var(--accent)]" /> BARKOD
          </div>
          <h1 className="font-display text-3xl sm:text-4xl md:text-5xl mt-1">Barkod</h1>
          <div className="text-xs text-[var(--text-muted)] mt-1">Barkod axını + API açarları</div>
        </div>
      </div>

      {/* Tabs */}
      <div className="border-b border-[var(--border)] mb-6 flex gap-1 overflow-x-auto">
        <TabBtn active={tab === "barcode"} onClick={() => setTab("barcode")} icon={Scan} label="Barkod → Məhsul" data-testid="vault-tab-barcode" />
        <TabBtn active={tab === "settings"} onClick={() => setTab("settings")} icon={Settings2} label="API Açarları" data-testid="vault-tab-settings" />
      </div>

      <div>
        {tab === "barcode" && <AdminVaultBarcode />}
        {tab === "settings" && <AdminVaultSettings />}
      </div>
    </div>
  );
}

function TabBtn({ active, onClick, icon: Icon, label, ...rest }) {
  return (
    <button
      onClick={onClick}
      className={`px-4 py-3 text-sm flex items-center gap-2 border-b-2 whitespace-nowrap transition-colors ${
        active
          ? "border-[var(--accent)] text-[var(--accent)]"
          : "border-transparent text-[var(--text-2)] hover:text-[var(--primary)]"
      }`}
      {...rest}
    >
      <Icon size={14} /> {label}
    </button>
  );
}
